import type { IntlKey } from 'locales';
import type { ActivityFilter, DateFilter } from 'state/blotters/common/blotter.model';

export interface IOption<T> {
  value: T;
}
export type SecondaryMarketPlatformFilter = 'AllPlatforms' | 'SGMarketsExecution' | 'SGMarketsExecutionApi';

const dateFilters: DateFilter[] = ['today', 'yesterday', 'oneWeek', 'twoWeeks', 'oneMonth', 'sixMonths', 'oneYear'];
const activityFilters: ActivityFilter[] = ['mySelf', 'myTeam'];
const platformFilters: SecondaryMarketPlatformFilter[] = [
  'AllPlatforms',
  'SGMarketsExecution',
  'SGMarketsExecutionApi',
];
const currencyFilters: string[] = [
  'AUD',
  'CAD',
  'CHF',
  'CNY',
  'CZK',
  'DKK',
  'EUR',
  'GBP',
  'HKD',
  'HUF',
  'ILS',
  'JPY',
  'MXN',
  'NOK',
  'NZD',
  'PLN',
  'RON',
  'RUB',
  'SEK',
  'SGD',
  'TRY',
  'USD',
  'ZAR',
];

export const availableDateFilters = (): ReadonlyArray<IOption<DateFilter>> =>
  dateFilters.map(dateFilter => ({
    value: dateFilter,
  }));

export const availableActivityFilters = (): ReadonlyArray<IOption<ActivityFilter>> =>
  activityFilters.map(activityFilter => ({
    value: activityFilter,
  }));

export const availableCurrencyFilters = (): ReadonlyArray<IOption<string>> =>
  currencyFilters.map(currencyFilter => ({
    label: currencyFilter,
    value: currencyFilter,
  }));

export const availablePlatformFilters = (): ReadonlyArray<IOption<SecondaryMarketPlatformFilter>> =>
  platformFilters.map(platform => ({
    label: platform,
    value: platform,
  }));

export function getPlatformTranslationKey(
  filter: SecondaryMarketPlatformFilter,
): `blotter.filter.secondaryMarketPlatform.${string}` & IntlKey {
  return `blotter.filter.secondaryMarketPlatform.${filter}`;
}
